export const INIT_MCQ_VIEW = 'INIT_MCQ_VIEW';
export const REQUEST_MCQ_SESSION = 'REQUEST_MCQ_SESSION';
export const RECEIVE_MCQ_SESSION = 'RECEIVE_MCQ_SESSION';
export const REQUEST_MCQ_RESET = 'REQUEST_MCQ_RESET';
export const RECEIVE_MCQ_RESET = 'RECEIVE_MCQ_RESET';
export const RECEIVE_USER_INFORMATION = 'RECEIVE_USER_INFORMATION';
export const COMPLETE_MCQ = 'COMPLETE_MCQ';
export const TOGGLE_ANSWER = 'TOGGLE_ANSWER';
export const TOGGLE_ANSWER_RECEIVE = 'TOGGLE_ANSWER_RECEIVE';
export const TOGGLE_ANSWER_FAIL = 'TOGGLE_ANSWER_FAIL';
export const TOGGLE_ACCEPT_CONDITIONS = 'TOGGLE_ACCEPT_CONDITIONS';
export const REQUEST_VALIDATION = 'REQUEST_VALIDATION';
export const SHOW_ALREADY_SUBITTED_WARNING = 'SHOW_ALREADY_SUBITTED_WARNING';
